import { render, staticRenderFns } from "./FLACCBehaviorRating.vue?vue&type=template&id=50bcca64&scoped=true"
import script from "./FLACCBehaviorRating.vue?vue&type=script&lang=js"
export * from "./FLACCBehaviorRating.vue?vue&type=script&lang=js"
import style0 from "./FLACCBehaviorRating.vue?vue&type=style&index=0&id=50bcca64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bcca64",
  null
  
)

export default component.exports